import { useState, useEffect } from 'react'
import { fetchGeom } from '../helpers/fetchGeom';

export const useFetchGeom = ( geoserverUrl, layerName, option ) => {

    const [coordinates, setCoordinates] = useState('');

    useEffect( () => {
        fetchGeom(geoserverUrl, layerName, option)
            .then( data => {              
                setCoordinates(data);
            })
    }, [layerName, option])
    return coordinates;
}